(function() {
    'use strict';

    angular.module('montage', [
            'ui.router',

            'montage.constants',
            'montage.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'montagePermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, montagePermissionsConst) {
        $stateProvider
            .state('layout.montage', {
                abstract: true,
                url: '/montages',
                data: {
                    title: 'Montaże',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.montage.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/montage/views/montage-list/montage-list.html',
                        controller: 'MontageListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: montagePermissionsConst.view
                }
            })
            .state('layout.montage.listArchive', {
                url: '/list-archive',
                views: {
                    'main@layout': {
                        templateUrl: 'app/montage/views/montage-list/montage-list.html',
                        controller: 'MontageListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    isArchive: true,
                    modelPermission: montagePermissionsConst.view
                }
            })
            .state('layout.montage.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/montage/views/montage-create/montage-create.html',
                        controller: 'MontageCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: montagePermissionsConst.view
                }
            })
            .state('layout.montage.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/montage/views/montage-update/montage-update.html',
                        controller: 'MontageUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: montagePermissionsConst.view
                }
            });
    }
})();
